import React from "react";

export default function StatusBar({ relay, serverCount, sync }) {
  return (
    <div style={{
      height: "32px",
      flexShrink: 0,
      background: "var(--surface2)",
      borderTop: "1px solid var(--border)",
      display: "flex",
      alignItems: "center",
      padding: "0 24px",
      fontSize: "11px",
      fontFamily: "var(--font-mono)",
      color: "var(--faint)",
      gap: "14px",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <div style={{
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          background: relay.color,
          boxShadow: `0 0 8px ${relay.color}`,
        }}></div>
        <span>{relay.text}</span>
      </div>
      <div style={{ width: "1px", height: "12px", background: "var(--border)" }}></div>
      <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        <span>{relay.url}</span>
      </div>
      <div style={{ width: "1px", height: "12px", background: "var(--border)" }}></div>
      <div>
        <span>Servers: {serverCount}</span>
      </div>
      <div style={{ width: "1px", height: "12px", background: "var(--border)" }}></div>
      <div style={{ display: "flex", alignItems: "center", gap: "3px" }}>
        <span>Hotkeys:</span>
        {[1, 2, 3, 4, 5, 6].map(k => (
          <kbd key={k} style={{
            background: "var(--surface)",
            border: "1px solid var(--border)",
            borderRadius: "3px",
            padding: "0 4px",
            fontSize: "9.5px",
            color: "var(--dim)",
          }}>{k}</kbd>
        ))}
        <span style={{ marginLeft: "4px" }}>tabs</span>
      </div>
      
      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "6px" }}>
        <span>Sync: {sync}</span>
      </div>
    </div>
  );
}
